export default "__VITE_ASSET__BWSnzBoz__"